export const PROJECT_NAME = 'Fast Mind';
export const APP_NAME = 'FASTMIND';
export const PAGINATION_SIZE = 30;
export const STUDENT_AUTH = APP_NAME + '_STUDENT_AUTH';
export const PAYMENT_PLAN = APP_NAME + '_SELECTED_PAYMENT_PLAN';